import { FC } from 'react';

const SubHeading: FC<{
  title: string;
  fullWidth?: boolean;
  className?: string;
}> = ({ title, fullWidth = false, className = '' }) => {
  if (!title) return null;
  return (
    <div>
      <h3
        className={`border-b-sub ${!fullWidth ? 'inline-block' : ''} ${className}`}
      >
        {title}
      </h3>
    </div>
  );
};

export default SubHeading;
